var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    {
      class: {
        "px-0": _vm.content.width === "full-width",
        [_vm.content.additionalClasses]: true,
      },
      attrs: { fluid: _vm.content.width === "full-width" },
    },
    [
      _c(
        "b-row",
        { attrs: { "no-gutters": _vm.content.width === "full-width" } },
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("div", { staticClass: "video-banner-box-outer" }, [
              _c(
                "div",
                {
                  staticClass: "video-banner-box",
                  class: [_vm.displayAspectRatio, _vm.displayBanner],
                },
                [
                  _vm.hasModalVideo
                    ? [
                        _c("VideoModal", {
                          attrs: {
                            show: _vm.showVideoModal,
                            "video-url": _vm.content.video_link.video_url,
                          },
                          on: {
                            close: function ($event) {
                              _vm.showVideoModal = false
                            },
                            stop: _vm.play,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "transition",
                          { attrs: { appear: "", name: "fade" } },
                          [
                            !_vm.backgroundVideoIsPlaying
                              ? _c("div", {
                                  staticClass: "video-banner-tint-overlay",
                                })
                              : _vm._e(),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "video-banner-tint video-banner-tint-dark",
                    style: { opacity: _vm.tint },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "effect-layer" }, [
                    _c(
                      "video",
                      {
                        ref: "video_element",
                        staticClass: "video-banner-display",
                        class: _vm.displayVideoFocus,
                        attrs: {
                          playsinline: "",
                          muted: "muted",
                          loop: "loop",
                          autoplay: true,
                          poster: _vm.videoPoster,
                        },
                        domProps: { muted: true },
                      },
                      [
                        _vm.noMotionPreferences
                          ? [
                              _c("source", {
                                attrs: {
                                  src: _vm.content.background_video.video_mp4,
                                  type: "video/mp4",
                                },
                              }),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                Sorry, there's a problem playing this video. Please try using a different browser.\n              "
                          ),
                        ]),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "controls" }, [
                    _c(
                      "div",
                      { staticClass: "video-banner-item-inner" },
                      [
                        _vm.content.description ||
                        _vm.content.title ||
                        _vm.content.leadline ||
                        _vm.hasBannerGraphic ||
                        _vm.content.hasPrimaryAction ||
                        _vm.content.hasSecondaryAction ||
                        _vm.hasModalVideo
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "video-banner-content",
                                  class: [
                                    _vm.content.BannerVerticalPosition,
                                    _vm.content.BannerHorizontalPosition,
                                  ],
                                },
                                [
                                  _c(
                                    "b-container",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "video-banner-content-inner",
                                                class: {
                                                  "px-3 px-md-5":
                                                    _vm.content.width !==
                                                    "full-width",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "video-banner-content-text",
                                                    class:
                                                      _vm.content
                                                        .BannerTextAlignment,
                                                  },
                                                  [
                                                    _vm.hasBannerGraphic
                                                      ? _c("VideoBoxLogo", {
                                                          attrs: {
                                                            content:
                                                              _vm.bannerGraphicSettings,
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.content.leadline
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "video-banner-leadline",
                                                          },
                                                          [
                                                            _c("h4", [
                                                              _vm._v(
                                                                "\n                                " +
                                                                  _vm._s(
                                                                    _vm.content
                                                                      .leadline
                                                                  ) +
                                                                  "\n                              "
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.content.title
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "video-banner-title",
                                                          },
                                                          [
                                                            _c("h1", [
                                                              _vm._v(
                                                                "\n                                " +
                                                                  _vm._s(
                                                                    _vm.content
                                                                      .title
                                                                  ) +
                                                                  "\n                              "
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.content.description
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "video-banner-description",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                              " +
                                                                _vm._s(
                                                                  _vm.content
                                                                    .description
                                                                ) +
                                                                "\n                            "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.content
                                                      .hasPrimaryAction ||
                                                    _vm.content
                                                      .hasSecondaryAction
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "video-banner-actions actions",
                                                          },
                                                          [
                                                            _vm.content
                                                              .hasPrimaryAction
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "video-banner-action-item",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "HighlightButton",
                                                                      {
                                                                        attrs: {
                                                                          url: _vm
                                                                            .content
                                                                            .primaryAction
                                                                            .linkUrl,
                                                                          title:
                                                                            _vm
                                                                              .content
                                                                              .primaryAction
                                                                              .linkText,
                                                                          icon: _vm
                                                                            .content
                                                                            .primaryAction
                                                                            .buttonIcon,
                                                                          "button-type":
                                                                            _vm
                                                                              .content
                                                                              .primaryAction
                                                                              .buttonType,
                                                                          "button-size":
                                                                            _vm
                                                                              .content
                                                                              .primaryAction
                                                                              .buttonSize,
                                                                          "button-style":
                                                                            _vm
                                                                              .content
                                                                              .primaryAction
                                                                              .buttonStyle,
                                                                          "icon-position":
                                                                            _vm
                                                                              .content
                                                                              .primaryAction
                                                                              .buttonIconPosition,
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.content
                                                              .hasSecondaryAction
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "video-banner-action-item",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "HighlightButton",
                                                                      {
                                                                        attrs: {
                                                                          url: _vm
                                                                            .content
                                                                            .secondaryAction
                                                                            .linkUrl,
                                                                          title:
                                                                            _vm
                                                                              .content
                                                                              .secondaryAction
                                                                              .linkText,
                                                                          icon: _vm
                                                                            .content
                                                                            .secondaryAction
                                                                            .buttonIcon,
                                                                          "button-type":
                                                                            _vm
                                                                              .content
                                                                              .secondaryAction
                                                                              .buttonType,
                                                                          "button-size":
                                                                            _vm
                                                                              .content
                                                                              .secondaryAction
                                                                              .buttonSize,
                                                                          "button-style":
                                                                            _vm
                                                                              .content
                                                                              .secondaryAction
                                                                              .buttonStyle,
                                                                          "icon-position":
                                                                            _vm
                                                                              .content
                                                                              .secondaryAction
                                                                              .buttonIconPosition,
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      [
                                                        _vm.hasModalVideo
                                                          ? _c(
                                                              "HighlightButton",
                                                              {
                                                                staticClass:
                                                                  "video-banner-video-action",
                                                                attrs: {
                                                                  disabled:
                                                                    !_vm.backgroundVideoIsPlaying,
                                                                  "button-type":
                                                                    "square",
                                                                  icon: "triangle-right",
                                                                },
                                                                nativeOn: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.openModalVid.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    },
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  [
                    _vm.hasFullBannerLink
                      ? _c("generic-link", {
                          staticClass: "full-banner-link",
                          attrs: { href: _vm.content.fullBannerLink.linkUrl },
                        })
                      : _vm._e(),
                  ],
                ],
                2
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }